<template>
	<div id="Assistant" class="assistant">
		<div class="body">
			<div class="elementos" v-show="messagesAssistant.length > 0">
				<div v-for="(message, index) in messagesAssistant" :key="index" class="elemento" :class="(index % 2 == 0) ? 'elemento-impar' : 'elemento-par'">
					<div class="container mensaje">
						<div class="wrapper">
							<div class="left">{{ message.role }}</div>
							<div class="center content" :class="(message.error) ? 'text-danger' : ''">
								<div v-if="message.role == 'user'">
									{{ message.content }}
								</div>
								<div v-else v-html="insertTagHtml(message.content)">
								</div>
							</div>
							<div class="right text-right">Opciones</div>
						</div>
					</div>
				</div>
			</div>
			<div class="dashboard" v-show="messagesAssistant.length == 0">
				<div class="container text-center">
					<h1 class="title">Asistente iSystem4</h1>
					<div class="row">
						<div class="col-md-4">
							<h5 class="mb-2">Ejemplos</h5>
							<div class="tarjeta">
								<div class="tarjeta-body" @click="insertPetitionLocal('print legal bol ', false)">
									<p class="tarjeta-text">Para pedir imprimir una boleta debes escribir: <i>print legal bol 1 3</i></p>
								</div>
							</div>
							<div class="tarjeta">
								<div class="tarjeta-body">
									<p class="tarjeta-text">With supporting text below as a natural lead-in to additional content.</p>
								</div>
							</div>
							<div class="tarjeta">
								<div class="tarjeta-body">
									<p class="tarjeta-text">With supporting text below as a natural lead-in to additional content.</p>
								</div>
							</div>
							<div class="tarjeta">
								<div class="tarjeta-body">
									<p class="tarjeta-text">With supporting text below as a natural lead-in to additional content.</p>
								</div>
							</div>
						</div>
						<div class="col-md-4">
							<h5 class="mb-2">Acciones</h5>
							<div class="tarjeta">
								<div class="tarjeta-body" @click.exact="insertPetitionLocal('isystem4', true)" @click.ctrl="insertPetitionLocal('isystem4 new', true)">
									<p class="tarjeta-text">Para ir a iSystem4 se tienes que escribir <i>isystem4</i> o haz click aquí</p>
								</div>
							</div>
							<div class="tarjeta">
								<div class="tarjeta-body" @click="insertPetitionLocal('aceschile', true)">
									<p class="tarjeta-text">Ir a la WEB de AcesChile o puedes escribir <i>aceschile</i></p>
								</div>
							</div>
						</div>
						<div class="col-md-4">
							<div class="tarjeta">
								<div class="tarjeta-body">
									<p class="tarjeta-text">With supporting text below as a natural lead-in to additional content.</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="search text-center">
				<div class="gradient">
				</div>
				<div class="input">
					<div class="container">
						<textarea rows="1"
							ref="textareaPrincipal"
							:disabled="askingAssistant"
							:placeholder="(askingAssistant) ? 'Espera mientras pienso...' : 'En que te puedo ayudar?'"
							v-model="petitionAssistant"
							@keydown="askAssistantLocal">
						</textarea>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'

import assistant from '@/mixins/generals/assistant.js'

export default {
	name: 'Assistant',
	mixins: [mixin, errors, axiosAction, assistant],
	data() {
		return {
			openAIId: 1,
			pruebas: 'hola <br> Mundo'
		}
	},
	methods: {
		_initModule() {
			const contenedor = this.$el.querySelector('.elementos');
			const ultimoElemento = contenedor.lastElementChild;
			contenedor.scrollTop = contenedor.scrollHeight;

			contenedor.addEventListener('DOMNodeInserted', () => {
				contenedor.scrollTop = contenedor.scrollHeight;
			});
		},
		askAssistantLocal(e) {
			if(e.keyCode === 13) {
				e.preventDefault()
				this.askAssistant(this.openAIId)
			}
		},
		askAssistantResultLocal(response) {
			setTimeout(() => { this.$refs.textareaPrincipal.focus() }, 100)
		},
		insertPetitionLocal(petition, execute = false) {
			this.insertPetition(petition, execute)
		},
		insertPetitionResultLocal() {
			setTimeout(() => { this.$refs.textareaPrincipal.focus() }, 100)
		},
		insertTagHtml(string) {
			string = string.replaceAll('\n\n\n\n\n\n\n\n', '<br>')
			string = string.replaceAll('\n\n\n\n\n\n', '<br>')
			string = string.replaceAll('\n\n\n\n', '<br>')
			string = string.replaceAll('\n\n', '<br>')
			string = string.replaceAll('``', '')
			string = string.replaceAll('`', '"')
			string = this.addClassExistTable(string)
			return string;
		},
		addClassExistTable(string) {
			return string.replaceAll('<table>', '<table class="table-assistant-result">')
		},
		resultAxiosLocal(responseLocal, response) {
			switch(responseLocal) {
				case 'askAssistantResult': this.askAssistantResult(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
        },
	},
	mounted() {
		this._initModule()
	}
}
</script>

<style lang="scss">
	@import './assets/css/assistant.scss';
</style>
